import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalError extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.state = {
			show: false,
			item:[],
			title:""

		}
	}

	componentDidMount(){
		this.props.onRef(this);	
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(item, title){
		this.setState({show:true, item:item, title:title});
		
		
	}

	handleClose(){
		this.setState({show:false, item:[], title:''});
	}
	
	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.title}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 carga">
		        			<table className="table table-hover error-carga">
		        				<thead>
		        					<tr>
		        						<th>Unidad</th>
		        						<th>Error</th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					{this.state.item.map((item, i)=>(
		        						<tr key={i}>
		        							<td>{item.unit_number}</td>
		        							<td>{item.error}</td>
		        						</tr>
		        					))}
		        				</tbody>
		        			</table>
	        				{/*<div className="col-xs-12">
	        					<div className="col-xs-12 col-sm-3">
	        						<label>Unidad</label>
	        					</div>
	        					<div className="col-xs-12 col-sm-9">
	        						<span>{this.state.item.unit_number}</span>
	        					</div>
	        				</div>
			        		<div className="col-xs-12">
			        			<div className="col-xs-12">
	        						<label>Error</label>
	        					</div>
	        					<div className="col-xs-12">
	        						<span>{this.state.item.error}</span>
	        					</div>
	        				</div>	*/}		        		
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalError)